var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscount70Bubble = function SvgDiscount70Bubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M23.25 12a3.75 3.75 0 0 0-2.618-3.576 3.75 3.75 0 0 0-5.057-5.057 3.751 3.751 0 0 0-7.151 0 3.751 3.751 0 0 0-5.057 5.057 3.752 3.752 0 0 0 0 7.152 3.751 3.751 0 0 0 5.057 5.056 3.752 3.752 0 0 0 7.15 0 3.752 3.752 0 0 0 5.058-5.056A3.75 3.75 0 0 0 23.25 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.832 6H9.75a.75.75 0 0 1 .7 1.013L8.582 12m7.918-1.5a1.5 1.5 0 1 1-3 0v-3a1.5 1.5 0 1 1 3 0zm-6.75 8.25 4.5-4.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M10.125 15a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75m3.75 4.5a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75"
  })));
};
export default SvgDiscount70Bubble;